export default __webpack_public_path__ + "bba8d96780a5ad76ed7dbeca276386ac.wav";